import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import AdminLogin from "@/components/AdminLogin";
import RequestsDashboard from "@/components/RequestsDashboard";

export default function AdminApp() {
  const [state, setState] = useState("checking");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
      credentials: "include",
    })
      .then((r) => setState(r.ok ? "in" : "out"))
      .catch(() => setState("out"));
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink">
        <Loader2 className="h-8 w-8 animate-spin text-steel" />
      </div>
    );
  }

  return state === "in" ? (
    <RequestsDashboard onLogout={() => setState("out")} />
  ) : (
    <AdminLogin onSuccess={() => setState("in")} />
  );
}
